// extracted by mini-css-extract-plugin
export default {"container":"NewAccountToast-module__container--ed98","link":"NewAccountToast-module__link--c1fb"};